export default function initTolltip() {
	let tooltipElem;
	let tooltipHtml = document.querySelectorAll('[data-tooltip]');

	if (tooltipHtml.length) {
		tooltipHtml.forEach((tooltip) => {
			tooltip.onmouseover = function(event) {
				let target = event.target;

				// ...создадим элемент для подсказки

				tooltipElem = document.createElement('div');
				tooltipElem.className = 'tooltip';
				tooltipElem.innerHTML = tooltip.getAttribute('data-tooltip');
				document.body.append(tooltipElem);

				// спозиционируем его сверху от аннотируемого элемента (top-center)
				let coords = target.getBoundingClientRect();

				let left = coords.left + (target.offsetWidth - tooltipElem.offsetWidth) / 2;
				// не заезжать за левый край окна
				if (left < 0) {
					// left = 0;
					left = coords.left - 8
					tooltipElem.classList.add('tooltip--left')
				} 

				let top = coords.top - tooltipElem.offsetHeight - 12;

				// если подсказка не помещается сверху, то отображать её снизу
				if (top < 0) { 
					top = coords.top + target.offsetHeight + 12;
					tooltipElem.classList.add('tooltip--bottom')
				}

				tooltipElem.style.left = left + 'px';
				tooltipElem.style.top = top + 'px';
			};

			tooltip.onmouseout = function(e) {
				if (tooltipElem) {
					tooltipElem.remove();
					tooltipElem = null;
				}
			};
		})
	}

}
